import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import useOrgPermissionInfo from '../../../services/hooks/useOrgPermissionInfo'
import { useCurrentItem } from '../../../Contexts/CurrentItemContext'
import classes from './index.module.css'

// Routes scoped to a single artist/entity — badge should be visible.
// Anything not matching (e.g. /artists, /songs/all, /data/) is hidden.
const SCOPED_ROUTE_PREFIXES = [
  '/artist/',
  '/song/',
  '/songs/artist/',
  '/songs/album/',
  '/albums/',
  '/edit-song/',
  '/feel/',
  '/tease/',
  '/teases/artist/',
  '/feels/artist/',
  '/create-tease/',
  '/edit-tease/',
  '/create-new-feel-step-1/',
  '/create-new-feel-step-2/',
]

/**
 * Display which organization/group is providing access and the user's permission level.
 * Styled to match GroupPreview tiles.
 * Only visible on routes scoped to a single artist/entity.
 */
export default function OrgPermissionBadge({ item: itemProp }) {
  const { pathname } = useLocation()
  const { item: contextItem } = useCurrentItem()
  const item = itemProp ?? contextItem
  const { orgName, groupName, orgImage, role, hasAccess } = useOrgPermissionInfo(item)

  // Only show on scoped routes (single artist/entity pages)
  const isScopedRoute = SCOPED_ROUTE_PREFIXES.some(prefix => pathname.startsWith(prefix))

  if (!isScopedRoute || !hasAccess || !role || !orgName) {
    return null
  }

  // Format location as "Team @ Org" or just "Org"
  const location = groupName ? `${groupName} @ ${orgName}` : orgName

  return (
    <div className={classes.card}>
      {orgImage ? (
        <span className={classes.image}>
          <img src={orgImage} alt={orgName} />
        </span>
      ) : orgName ? (
        <span className={`${classes.image} ${classes.image__empty}`}>
          <span>{orgName.charAt(0).toUpperCase()}</span>
        </span>
      ) : null}
      <div className={classes.card__details}>
        <h3 className={classes.card__title}>{role}</h3>
        {location && <p className={classes.card__text}>{location}</p>}
      </div>
    </div>
  )
}

OrgPermissionBadge.propTypes = {
  item: PropTypes.object,
}
